export const OBJECT_CONTEXT_MENU_NAME = 'object-context-menu';
